import React from 'react'
import PropTypes from 'prop-types'
import { Switch, Route, Redirect } from 'react-router-dom'

import TrainPositionsApp from '../containers/TrainPositionsApp'
import SingleTrainModal from '../containers/SingleTrainModal'
import TrainInfoModal from '../containers/TrainInfoModal'
import TrainOperationInfo from '../containers/TrainOperationInfo'

import StationDetail from'../containers/StationDetail'
import Restroom from'../containers/Restroom'
import RestroomMap from '../components/restroom/Map';

// Viewのみ
import Maintenance from '../components/maintenance/Maintenance'
import NetworkError from '../components/network_error/NetworkError'

export default class App extends React.Component {
  static contextTypes = {
    intl: PropTypes.object
  }

  render() {
    return (
      <Switch>
        <Route exact path="/lines/:lineName/trains" component={TrainPositionsApp} />
        <Route exact path="/lines/:lineName/train_operation_info" component={TrainOperationInfo} />
        <Route path="/lines/:lineName/trains/info/:trainNumber" component={TrainInfoModal} />
        <Route path="/lines/:lineName/trains/:trainNumber" component={SingleTrainModal} />
        <Route exact path="/lines/:lineName/stations/:stationId" component={StationDetail} />

        <Route exact path="/lines/koya/stations/1/restroom" render={() => (
          <Redirect to={`/lines/nankai/stations/1/restroom`} />
        )} />

        <Route exact path="/lines/:lineName/stations/:stationId/restroom" component={Restroom} />
        <Route exact path="/lines/:lineName/stations/:stationId/restroom/facilities/:facilityId/rooms/:roomId/map" component={RestroomMap} />
        <Route path="/maintenance" component={Maintenance} />
        <Route path="/network_error" component={NetworkError} />

      </Switch>
    )
  }
}

